import type { FreeCreditsTask } from '@/app/types';

export const getRemainingTaskReward = (task: FreeCreditsTask): number => {
  if (task.finished || task.state === 'finished' || task.state === 'expired') {
    return 0;
  }

  const eachReward = task.credits_award ?? 0;
  const totalTimes = task.total_times && task.total_times > 0 ? task.total_times : 1;
  const finishedTimes = Math.max(task.finished_times ?? 0, 0);
  const totalReward = task.max_reward && task.max_reward > 0 ? task.max_reward : eachReward * totalTimes;

  return Math.max(totalReward - eachReward * finishedTimes, 0);
};
